import { baseUrl, buildQueryParams } from "./Requests.js";
import { useQuery } from "@tanstack/react-query";

const WEB_MAIN_FIRST_QUERY_KEY = ["webMain", "first"];

async function getWebMainFirstSection(options = {}) {
  const params = {
    category: "guru",
    size: 5,
  };
  const query = buildQueryParams(params);
  const url = `${baseUrl}/web_main/first?${query}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    signal: options.signal,
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(`Dashboard first section request failed: ${response.status}`);
  }

  return response.json();
}

async function getWebMainSecondSection(tickers) {
 const query = buildQueryParams({
    tickers: tickers,
  });
  const url = `${baseUrl}/web_main/second?${query}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(`Dashboard first section request failed: ${response.status}`);
  }

  return response.json();
}

function useWebMainFirstQuery() {
  return useQuery({
    queryKey: WEB_MAIN_FIRST_QUERY_KEY,
    queryFn: ({ signal }) => getWebMainFirstSection({ signal }),
    staleTime: 1000 * 60 * 60 * 2,
    gcTime: 1000 * 60 * 60 * 2,
  });
}

export { WEB_MAIN_FIRST_QUERY_KEY, getWebMainFirstSection, getWebMainSecondSection, useWebMainFirstQuery };
